import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../../../api/services/project.services';
import { ActivatedRoute } from '@angular/router';
import { Project } from '../../../api/models/project-model';
import { Observable } from 'rxjs/Observable';
import { PreferencesService } from '../../../api/services/preferences.service';
import { AuthService } from '../../../api/services/auth.service';
import { Worksheet } from '../../../api/models/worksheet';
import { of } from 'rxjs/observable/of';
import { Task } from '../../../api/models/task';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { MarketService } from '../../../api/services/market.service';
import { Address } from '../../../api/models/address';
import { AddressCreationComponent } from '../../address-creation/address-creation.component';
import { OrderTableComponent } from '../../order-table/order-table.component';
import { OrderCreateComponent } from '../../order-create/order-create.component';
import { ProjectCreationComponent } from '../../project-creation/project-creation.component';
import { Market } from '../../../api/models/market-model';
import { UserService } from '../../../api/services/user.service';
import { Team } from '../../../api/models/team';
import { UserInfo } from '../../../api/models/user-model';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { TasksService } from '../../../api/services/tasks.service';
import { ProjectHealthComponent } from '../project-health/project-health.component';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { MarketBannerService } from '../../market-banner/market-banner.service';

@Component({
  selector: 'app-dashboard-my-oasis-detail',
  templateUrl: './dashboard-my-oasis-detail.component.html',
  styleUrls: ['./dashboard-my-oasis-detail.component.scss']
})
export class DashboardMyOasisDetailComponent implements OnInit {

  private VERIZON_DATE_FORMAT_REGEX = '(0[1-9]|1[012])/(0[1-9]|[12][0-9]|3[01])/([0-9]{2})';
  
  backToSearch: string;

  project: Project;

  projectForm: FormGroup;
  atcFieldsForm: FormGroup;
  verizonFieldsForm: FormGroup;
  atcExpanded = false;

  orders: Observable<any>;
  tasksOrders: Worksheet[] = [];

  canViewSpendingSummary = false;
  canCreateWorksheet = false;
  canCreateAddress = false;
  canViewAvailability = false;

  specialSelected: string;
  selectedRiskLevel: string;

  projectFields: any;
  isRecA: boolean = false;

  defaultIcon = '&#xe' + (2306).toString(16);

  verizonOptions = ['Value 1', 'Value 2', 'Value 3'];
  atcFields: any;
  verizonFields: any;
  verizonFlag: boolean;

  addresses: Address[];
  siteAddressId: string;

  showInitiatorsApprovers = false;
  canEditPermissions = false;
  market: Market;
  teams: Team[] = [];
  users: UserInfo[] = [];
  projectInitiators = [];
  projectApprovers = [];
  marketInitiators = [];
  marketApprovers = [];
  marketApprovers2 = [];
  errorMessage : string[] = [];
  $updatePermissionsSubject = new Subject<any>();
  $updateErrorMessageSubject = new Subject<string>();
  loading: boolean;
  roleRequest: RoleRequest;
  contractorTeamType: number = 2;

  healthFlag: boolean = false;
  editFlag: boolean = false;
  subTotalFlag: boolean = false
  marketDetailsLoaded: boolean = false;

  @ViewChild(OrderTableComponent) orderTable: OrderTableComponent;
  @ViewChild(ProjectHealthComponent) projectHealthComponent: ProjectHealthComponent;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private projectService: ProjectService,
    private preferencesService: PreferencesService,
    private authService: AuthService,
    private marketService: MarketService,
    private userService: UserService,
    private tasksService: TasksService,
    private marketBannerService: MarketBannerService,
  ) { }

  private onUpdateSuccess(msg: string) {
    this.toastr.success(msg, 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateError(msg: string) {
    this.toastr.error(msg, 'Fail!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  toggleInitiatorsAndApprovers() {
    this.showInitiatorsApprovers = !this.showInitiatorsApprovers;
  }

  setTeams() {
    this.project.projectPermissions = [];
    this.projectInitiators.forEach(initiator => {
      const type = initiator.isTeam ? 'USER_GROUP' : 'USER';
      this.project.projectPermissions.push({ roleType: '0', target: `${type}~${initiator.id}`, marketInherit: false });
    });
    this.projectApprovers.forEach(approver => {
      const type = approver.isTeam ? 'USER_GROUP' : 'USER';
      this.project.projectPermissions.push({ roleType: '1', target: `${type}~${approver.id}`, marketInherit: false });
    });
    this.project.updateProjectPermission = true;
  }

  getPermissionsUserIds() {
    const userIds = [];
    this.market.marketPermissions.forEach(p => {
      if (this.getTargetType(p.target) === 'USER' && !p.isAdmin) {
        userIds.push(this.getTargetId(p.target));
      }
    });
    this.project.projectPermissions.forEach(p => {
      if (this.getTargetType(p.target) === 'USER' && !p.marketInherit) {
        userIds.push(this.getTargetId(p.target));
      }
    });
    return userIds;
  }

  getPermissionsTeamIds() {
    const teamIds = [];
    this.market.marketPermissions.forEach(p => {
      if (this.getTargetType(p.target) === 'USER_GROUP' && !p.isAdmin) {
        teamIds.push(this.getTargetId(p.target));
      }
    });
    this.project.projectPermissions.forEach(p => {
      if (this.getTargetType(p.target) === 'USER_GROUP' && !p.marketInherit) {
        teamIds.push(this.getTargetId(p.target));
      }
    });
    return teamIds.join(',');
  }

  fillInitiatorsAndApprovers() {
    this.marketInitiators = [];
    this.marketApprovers = [];
    this.projectInitiators = [];
    this.projectApprovers = [];
    this.market.marketPermissions.forEach(permission => {
      if (!permission.isAdmin) {
        const isTeam = this.getTargetType(permission.target) === 'USER_GROUP';
        let name;
        let temp;
        if (isTeam && this.teams) {
          temp = this.teams.find(team => team.id === this.getTargetId(permission.target));
          name = temp ? temp.name : null;
        } else if (this.users) {
          temp = this.users.find(user => user.userId === this.getTargetId(permission.target));
          name = temp ? temp.displayName : null;
        }
        if (name) {
          switch (permission.roleType) {
            case '0':
              this.marketInitiators.push({ id: this.getTargetId(permission.target), name: name, isTeam: isTeam, display: name, value: this.getTargetId(permission.target)  });
              break;
            case '1':
              this.marketApprovers.push({ id: this.getTargetId(permission.target), name: name, isTeam: isTeam, display: name, value: this.getTargetId(permission.target)  });
              break;
            case '2':
              this.marketApprovers2.push({ id: this.getTargetId(permission.target), name: name, isTeam: isTeam, display: name, value: this.getTargetId(permission.target)  });
              break;
          }
        }
      }
    });
    this.project.projectPermissions.forEach(permission => {
      if (!permission.marketInherit) {
        const isTeam = this.getTargetType(permission.target) === 'USER_GROUP';
        let name;
        let temp;
        if (isTeam && this.teams) {
          temp = this.teams.find(team => team.id === this.getTargetId(permission.target));
          name = temp ? temp.name : null;
        } else if (this.users) {
          temp = this.users.find(user => user.userId === this.getTargetId(permission.target));
          name = temp ? temp.displayName : null;
        }
        if (name) {
          switch (permission.roleType) {
            case '0':
              this.projectInitiators.push({ id: this.getTargetId(permission.target), name: name, isTeam: isTeam, display: name, value: this.getTargetId(permission.target) });
              break;
            case '1':
              this.projectApprovers.push({ id: this.getTargetId(permission.target), name: name, isTeam: isTeam, display: name, value: this.getTargetId(permission.target) });
              break;
          }
        }
      }
    });
  }

  getTargetId(target: string): string {
    return target.split('~')[1];
  }

  getTargetType(target: string): string {
    return target.split('~')[0];
  }

  isMarketInherit(id: string) {
    return this.marketInitiators.map(ini => ini.id).find(iniId => iniId === id) ||
      this.marketApprovers.map(app => app.id).find(appId => appId === id) ||
      this.marketApprovers2.map(app => app.id).find(appId => appId === id);
  }

  autocompleteInitiators = (text: string) => {
    return this.authService.findTeamsAndUsersByOrganizationIdAndText(this.project.organizationId, text)
      .pipe(map(data => data.filter(entity => !entity.isAdmin)))
      .pipe(map(data => data.filter(entity => entity.isTeam ? entity.teamType === 0 : entity)))
      .pipe(map(data => data.map(entity => {
        return { name: entity.fullname, id: entity.id, isTeam: entity.isTeam };
      })));
  }

  autocompleteApprovers = (text: string) => {
    return this.authService.findTeamsAndUsersByOrganizationIdAndText(this.project.organizationId, text)
      .pipe(map(data => data.filter(entity => !entity.isAdmin)))
      .pipe(map(data => data.filter(entity => entity.isTeam ? entity.teamType === 1 : entity)))
      .pipe(map(data => data.map(entity => {
        return { name: entity.fullname, id: entity.id, isTeam: entity.isTeam };
      })));
  }

  newOrder() {
    const modalRef = this.modalService.open(OrderCreateComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });    
    modalRef.componentInstance.project = this.project;

    let newWorksheet: Worksheet = new Worksheet();
    newWorksheet.requestedDeliveryDate = this.project.deliveryDate;
    if (this.specialSelected === 'Verizon eQuote') {
      newWorksheet.siteName = this.project.name;
      if (this.tasksOrders && this.tasksOrders.length) {
        newWorksheet.atcApproverId = this.tasksOrders[0].atcApproverId;
        newWorksheet.initiatorTeamId = this.tasksOrders[0].initiatorTeamId;
      }
    }
    modalRef.componentInstance.worksheet = newWorksheet;
    modalRef.componentInstance.action = 'Create';
    modalRef.result.then(() => {
      //No action to be performed
     }).catch(() => { 
       //Empty catch block
     });
  }

  getUpdatedFields(form: any, original: any) {
    const fields = [];
    for (const key in form) {
      if (original[key] !== form[key]) {
        const changedField = {
          code: key,
          value: form[key]
        };
        fields.push(changedField);
      }
    }
    return fields;
  }

  addAddress(addressName: string) {
    const modalRef = this.modalService.open(AddressCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.addressName = addressName;
    modalRef.componentInstance.flag = false;
    modalRef.result.then((address) => {
      this.marketService.getAddresses(this.project.marketId).subscribe(addresses => {
        this.addresses = addresses;
        const newAddress = addresses.find(a => a.locationName.toLowerCase() === address.locationName.toLowerCase());
        this.setSiteAddress(newAddress.id);
      });
    }).catch(() => {
      this.siteAddressId = '-1';
    });
  }


  setSiteAddress(addressId: string) {
    if (addressId === '-1') {
      this.addAddress('');
    } else if (this.siteAddressId !== '-2' && addressId === '-2') {
      this.preferencesService.setPreference('PROJECT', this.project.id, 'site-address', { Value: '' }).subscribe(() => {
        this.siteAddressId = '-2';
        this.onUpdateSuccess('Project address preference removed!!!');
      });
    } else {
      const address = this.addresses.find(a => a.id === addressId);
      this.preferencesService.setPreference('PROJECT', this.project.id, 'site-address', { Value: address.id }).subscribe(() => {
        this.siteAddressId = address.id;
        this.onUpdateSuccess('Project saved!!!');
      });
    }
  }

  editProject() {
    const modalRef = this.modalService.open(ProjectCreationComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.project = Object.assign({},this.project);
    modalRef.componentInstance.specialSelected = this.specialSelected;
    modalRef.componentInstance.action = 'Update';


    modalRef.result.then((arr) => {
      if (this.verizonFieldsForm && arr) {
        if(arr[0] && arr[0].length) {
          this.verizonFieldsForm.patchValue({
            'oracle-project-number': arr[0]
          });
        }
        if (arr[1] && arr[1].length) {
          this.verizonFieldsForm.patchValue({
            'oracle-project-name': arr[1]
          });
        }
      }
      this.projectService.getProjectById(this.project.id, true, true).subscribe(project => {
        this.project = project;
        this.teams = [];
        this.users = [];
        forkJoin(
          this.authService.getTeamsByTeamIds(this.getPermissionsTeamIds()),
          this.userService.getUserDisplayNames(this.getPermissionsUserIds())).subscribe(result => {
            this.teams = result[0];
            this.users = result[1];
            this.fillInitiatorsAndApprovers();
          });
      });
    }).catch(() => { 
      //Empty catch block
    });
  }

  ngOnInit() {
    this.setLoading(true);

    this.route.queryParams.subscribe(params => {
      this.backToSearch = params['backToSearch'];
    });

    this.route.params.map(p => p.id).subscribe(projectId => {
        this.projectService.getProjectById(projectId, true, true)
          .subscribe(project => {
            if (this.userService.isMarketPermittedForCurrentUser(project.marketId)) {
              this.project = project;
              this.setAuthorizations(this.project);

              this.getWorksheetsWithTasks(project);
              
              this.marketService.getMarket(this.project.marketId).subscribe(market => {
                this.market = market;
                this.marketBannerService.storeMarketDetailsInLocalStorage(this.market);
                this.marketDetailsLoaded = true;
                forkJoin(
                  this.authService.getTeamsByTeamIds(this.getPermissionsTeamIds()),
                  this.userService.getUserDisplayNames(this.getPermissionsUserIds())).subscribe(result => {
                    this.teams = result[0];
                    this.users = result[1];
                    this.fillInitiatorsAndApprovers();
                  });
              });

              this.marketService.getAddresses(this.project.marketId).subscribe(addresses => {
                this.addresses = addresses;
              });

              this.preferencesService.getPreferences('PROJECT', this.project.id).subscribe(prefs => {
                this.projectFields = prefs;
                if (prefs && prefs['site-address'].Value && prefs['site-address'].Value.length > 0) {
                  this.siteAddressId = prefs['site-address'].Value;
                } else {
                  this.siteAddressId = '-2';
                }

                this.preferencesService.getPreferences('CUSTOMER', this.project.organizationId).subscribe(prefs => {
                  this.specialSelected = prefs['special-fields'].Value;
                  if (this.specialSelected === 'ATC') {
                    this.setValuesForATCProject();
                  } else if (this.specialSelected === 'Verizon eQuote') {
                    this.setValuesForVerizonProject();   
                  }else if (this.specialSelected === 'Standard') {
                    this.setValuesForStandardClientProject();   
                  }
                });
              });

              this.$updatePermissionsSubject
                .debounceTime(2000)
                .subscribe(() => {
                  this.setTeams();
                  this.projectService.updateProject(this.project).subscribe(() => {
                    this.onUpdateSuccess('Project saved!!!');
                  }, err => {
                    this.onUpdateError(err.error.message);
                  });
                });
              this.setLoading(false);
              this.$updateErrorMessageSubject.subscribe(message => {
                this.errorMessage.push(message);
              });
            } else {
              this.project = null;
              this.setLoading(false);
              this.errorMessage.push("You don't have permission to view this page!!!");
            }
        }, error => {
          this.project = null;
          this.setLoading(false);
          this.errorMessage.push(error.error.message);
        });
      });
  }

  setValuesForATCProject(){
    this.healthFlag = true;
    this.editFlag = false;
    this.subTotalFlag = false;
    this.atcFieldsForm = this.formBuilder.group({
      'oracle-project-number': [this.projectFields['oracle-project-number'].Value || ''],
      'workflow-number': [this.projectFields['workflow-number'].Value || ''],
      'oracle-project-name': [this.projectFields['oracle-project-name'].Value || ''],
      'siterra-project-number': [this.projectFields['siterra-project-number'].Value || ''],
      'case-management-number': [this.projectFields['case-management-number'].Value || ''],
      'construction-manager': [this.projectFields['construction-manager'].Value || ''],
      'general-contractor': [this.projectFields['general-contractor'].Value || ''],
      'site-number': [this.projectFields['site-number'].Value || '']
    });
    this.atcFields = this.atcFieldsForm.value;

    this.atcFieldsForm.valueChanges
      .debounceTime(2000)
      .subscribe(form => {
        const fieldsUpdated = this.getUpdatedFields(form, this.atcFields);
        this.atcFields = form;
        forkJoin(
          fieldsUpdated.map(field =>
            this.preferencesService.setPreference('PROJECT', this.project.id, field.code, { Value: field.value })
          ))
          .subscribe(result => {
            this.onUpdateSuccess('Project saved!!!');
          });
      });
  }

  setValuesForVerizonProject(){
    this.verizonFlag = true;
    this.healthFlag = false;
    this.editFlag = true;
    this.subTotalFlag = true;
    this.isRecA = this.project.reca;
    let opnu = this.projectFields['oracle-project-number'];
    let opna = this.projectFields['oracle-project-name'];
    let pCode = this.projectFields['project-code'];
    let lCode = this.projectFields['location-code'];
    this.verizonFieldsForm = this.formBuilder.group({
      'oracle-project-number': [opnu && opnu.Value ? opnu.Value : ''],
      'oracle-project-name': [opna && opna.Value ? opna.Value : ''],
      'project-code': [pCode && pCode.Value ? pCode.Value : ''],
      'location-code': [lCode && lCode.Value ? lCode.Value : '']
    });
    this.verizonFields = this.verizonFieldsForm.value;
  
    this.verizonFieldsForm.valueChanges
      .debounceTime(2000)
      .subscribe(form => {
          const fieldsUpdated = this.getUpdatedFields(form, this.verizonFields);
          this.verizonFields = form;
          forkJoin(
            fieldsUpdated.map(field =>
              this.preferencesService.setPreference('PROJECT', this.project.id, field.code, { Value: field.value })
            ))
            .subscribe(result => {
              this.onUpdateSuccess('Project saved!!!');
            });
      });
  }

 setValuesForStandardClientProject(){
    this.healthFlag = false;
    this.editFlag = true;
    this.subTotalFlag = true;
    let opnu = this.projectFields['oracle-project-number'];
    let opna = this.projectFields['oracle-project-name'];
    let pCode = this.projectFields['project-code'];
    let lCode = this.projectFields['location-code'];
    this.verizonFieldsForm = this.formBuilder.group({
      'oracle-project-number': [opnu && opnu.Value ? opnu.Value : ''],
      'oracle-project-name': [opna && opna.Value ? opna.Value : ''],
      'project-code': [pCode && pCode.Value ? pCode.Value : ''],
      'location-code': [lCode && lCode.Value ? lCode.Value : '']
    });
    this.verizonFields = this.verizonFieldsForm.value;
  
    this.verizonFieldsForm.valueChanges
      .debounceTime(2000)
      .subscribe(form => {
          const fieldsUpdated = this.getUpdatedFields(form, this.verizonFieldsForm);
          this.verizonFields = form;
          forkJoin(
            fieldsUpdated.map(field =>
              this.preferencesService.setPreference('PROJECT', this.project.id, field.code, { Value: field.value })
            ))
            .subscribe(result => {
              this.onUpdateSuccess('Project saved!!!');
            });
      });
  }

  setAuthorizations(project: Project) {
    this.authService.getUserTeamByType(this.authService.getUserId(), this.contractorTeamType).subscribe(team => {
      this.roleRequest = new RoleRequest('PRICING_VIEW', null);
      this.roleRequest.setRoleAndContextMap('AVAILABILITY_VIEW', null);
      this.roleRequest.setRoleAndContextMap('ADMIN_TESSCO', null);
      this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', `ORGANIZATION~${project.organizationId}`);
      if (project.inheritMarketPermissions && team.type !== this.contractorTeamType) {
        this.roleRequest.setRoleAndContextMap('WORKSHEET_CREATE', `MARKET~${project.marketId}`);
        this.roleRequest.setRoleAndContextMap('ADDRESS_CREATE', `MARKET~${project.marketId}`);
      } else if (team.type === this.contractorTeamType) {
        this.roleRequest.setRoleAndContextMap('WORKSHEET_CREATE', `PROJECT~${project.id}`);
        this.roleRequest.setRoleAndContextMap('ADDRESS_CREATE', `MARKET~${project.marketId}`);
      } else {
        this.roleRequest.setRoleAndContextMap('WORKSHEET_CREATE', `PROJECT~${project.id}`);
        this.roleRequest.setRoleAndContextMap('ADDRESS_CREATE', `PROJECT~${project.id}`);
      }
      this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
        this.canViewSpendingSummary = roles.getRoleMap('PRICING_VIEW');
        this.canViewAvailability = roles.getRoleMap('AVAILABILITY_VIEW');
        this.canEditPermissions = roles.getRoleMap('ADMIN_TESSCO') || roles.getRoleMap('ADMIN_CLIENT');
        this.canCreateWorksheet = roles.getRoleMap('WORKSHEET_CREATE') || roles.getRoleMap('ADMIN_CLIENT');
        this.canCreateAddress = roles.getRoleMap('ADDRESS_CREATE') || roles.getRoleMap('ADMIN_CLIENT');
      });
    });
  }

  onAppliedFilter(filter: any) {
    if (filter.type === 'task') {
      if (filter.filter === 'onTarget') {
        this.orders = of(this.tasksOrders.filter(order => !order.tasks));
      } else if (filter.filter === 'offTarget') {
        this.orders = of(this.tasksOrders.filter(order => order.tasks));
      } else {
        this.orders = of(this.tasksOrders);
      }
    } else if (filter.type === 'health') {
      if (filter.filter !== 'all') {
        this.orderTable.filterByKind('Order');
        this.orders = of(this.tasksOrders.filter(o => filter.ids.includes(o.id)));
      } else {
        this.orders = of(this.tasksOrders);
      }
    }
  }

  getWorksheetsWithTasks(project: Project) {
    this.projectService.getWorksheetsByProjectIdV2(project.id).subscribe(orders => {
      this.tasksOrders = orders;
      if (orders.length > 0) {
        this.tasksService.getTasksByProject(project.name, project.accountNumber).subscribe(tasks => {
          tasks.forEach((task: Task) => {
            if (task.opened) {
              const id = task.worksheetID;
              const matchedTaskOrders = this.tasksOrders.find(w => w.id === id);
              if (matchedTaskOrders && matchedTaskOrders.tasks) {
                this.tasksOrders.find(w => w.id === id).tasks.push(task);
              } else if (matchedTaskOrders) {
                this.tasksOrders.find(w => w.id === id).tasks = [task];
              }
            }
          });
        });
      }
      this.orders = of(this.tasksOrders);
    });
  }

  markReca(event){
    if(!this.isRecA){
      event.target.checked = !event.target.checked;
      this.recAProject(this.project);
    }
  }
    
  markNonReca(event){
    if(this.isRecA){
      event.target.checked = !event.target.checked;
      this.nonRecaProject(this.project);
    }
  }

  recAProject(item: Project) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Confirmation!";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to mark <strong>${item.name}</strong> as REC(A)?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
    modalRef.componentInstance.fn = () => {
      this.projectService.recAProject(item.id).subscribe(() => {
        modalRef.close();
        modalRef.result.then(() => {
          this.projectService.getProjectById(this.project.id, true, true)
          .subscribe(project => {
            this.project = project;
            this.isRecA = this.project.reca;
            this.onUpdateSuccess("Project " + item.name + " marked REC(A)");
          })
        }).catch();
      },error => {
        modalRef.close();
        this.onUpdateError("Error while making project " + item.name + " as REC(A)");
      });
    };
  }

  nonRecaProject(item: Project) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.headerMsg = "Confirmation!";
    modalRef.componentInstance.bodyMsg = `Are you sure you want to mark <strong>${item.name}</strong> as Non REC(A)?`;
    modalRef.componentInstance.primaryButtonText = "Yes, Proceed";
    modalRef.componentInstance.fn = () => {
      this.projectService.activeProject(item.id).subscribe(() => {
        modalRef.close();
        modalRef.result.then(() => {
          this.projectService.getProjectById(this.project.id, true, true)
          .subscribe(project => {
            this.project = project;
            this.isRecA = this.project.reca;
            this.onUpdateSuccess("Project " + item.name + " marked as Non REC(A)");
          })
        }).catch();
      },error => {
        modalRef.close();
        this.onUpdateError("Error while making project " + item.name + " as Non REC(A)");
      });
    };
  }

  getLoading() {
    return this.loading;
  }

  setLoading(value: boolean) {
    this.loading = value;
  }

  updateTasksCount() {
    this.projectHealthComponent.setOpenTasks();
  }
  
  toggleATCExpandIcon(){
    this.atcExpanded = !this.atcExpanded;
  }

}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/dashboard-my-oasis-detail/dashboard-my-oasis-detail.component.ts